// Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content. 

import { BaseURLAuthClientConfig } from "@asgardeo/auth-react";

declare global {
  interface Window {
    config: {
      APP_NAME: string;
      APP_DOMAIN: string;
      ASGARDEO_BASE_URL: string;
      ASGARDEO_CLIENT_ID: string;
      ASGARDEO_REVOKE_ENDPOINT: string;
      AUTH_SIGN_IN_REDIRECT_URL: string;
      AUTH_SIGN_OUT_REDIRECT_URL: string;
      REACT_APP_BACKEND_BASE_URL: string;
    };
  }
}

export const AsgardeoConfig: BaseURLAuthClientConfig = {
  scope: ["openid", "email", "groups"],
  baseUrl: window.config?.ASGARDEO_BASE_URL ?? "",
  clientID: window.config?.ASGARDEO_CLIENT_ID ?? "",
  signInRedirectURL: window.config?.AUTH_SIGN_IN_REDIRECT_URL ?? "",
  signOutRedirectURL: window.config?.AUTH_SIGN_OUT_REDIRECT_URL ?? "",
};

export const APP_NAME = window.config?.APP_NAME ?? "";
export const APP_DOMAIN = window.config?.APP_DOMAIN ?? "";
export const ServiceBaseUrl = window.config?.REACT_APP_BACKEND_BASE_URL ?? "";

export const AppConfig = {
  serviceUrls: {
    repositoryRequests: ServiceBaseUrl + "/repository-requests",
    userInfo: ServiceBaseUrl + "/user-info",
    employees: ServiceBaseUrl + "/employees",
    teams: ServiceBaseUrl + "/teams",
    topics: ServiceBaseUrl + "/topics",
    leads: ServiceBaseUrl + "/leads",
    organizations: ServiceBaseUrl + "/organizations",
    comments: (requestId: number) => `${ServiceBaseUrl}/repository-requests/${requestId}/comments`,
    defaultTeams: ServiceBaseUrl + "/default-teams",
  },
  markdownUrls: {
    overview: "/doc/userGuide/Overview.md",
    submitRequest: "/doc/userGuide/SubmitRequest.md",
    requestHistory: "/doc/userGuide/RequestHistory.md",
    adminGuide: "/doc/userGuide/AdminGuide.md",
    additionalDetails: "/doc/userGuide/AdditionalDetails.md",
    troubleshoot: "/doc/userGuide/Troubleshoot.md",
  },
};

export const GITHUB_REPO_NAME_MAX = 100;
export const GITHUB_DESCRIPTION_MAX = 350;
export const GITHUB_TOPIC_MAX_COUNT = 20;
export const GITHUB_TOPIC_MAX_LENGTH = 50;

export const ALLOWED_URL_PROTOCOLS = ["http:", "https:"];

/**
 * Feature flags for controlling UI behavior at runtime.
 * 
 * Cleanup:
 * - Remove this flag and related conditions once the feature is fully implemented.
 */
export const CICD_CONFIGURATION_ENABLE = false;
